<template>
  <div class="setting-main-container">
    <form action="" @submit.prevent="submitBusinessData">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.financial_institutions.financial_institutions') }}</h3>
        </div>
        <div class="row">
            <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_institutions.imports') }}</label>
                <base-input
                v-model="formData.imports"        
                />
            </div>
            <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_institutions.exports') }}</label>
                <base-input
                v-model="formData.exports"        
                />
            </div>
            <div class="col-md-12 mb-4">
                <label class="input-label">{{ $tc('profile.financial_institutions.remittances_effect') }}</label>
                <base-text-area
                v-model="formData.remittances_effected"  
                 @input="$v.formData.remittances_effected.$touch()"    
                      
                />
                <div v-if="$v.formData.remittances_effected.$error">
                <span v-if="!$v.formData.remittances_effected.maxLength" class="text-danger">{{ $tc('validation.remittances_effected_maxlength') }}</span>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <base-button
              :loading="isLoading"
              :disabled="isLoading"
              icon="save"
              color="theme"
              type="submit"
            >
              {{ $tc('profile.business_status.save') }}
            </base-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import IconUpload from '../../components/icon/upload'
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, email, maxLength } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      formData: {
        remittances_effected: null,
        imports:null,
        exports:null,
      },
      isLoading: false,
     
    }
  },
  watch: {
  },
  validations: {
    formData: {
      remittances_effected: {
        maxLength: maxLength(255)
      },
    }
  },
  computed: {
    ...mapGetters('business', [
      'business'
    ]),
   
  }, 
  created() {
      if(this.business){
        this.formData.id=this.business.id
      }  
      if(this.business && this.business.imports){
        this.formData.imports=this.business.imports
      }
      if(this.business && this.business.exports){
        this.formData.exports=this.business.exports
      }
      if(this.business && this.business.remittances_effected){
        this.formData.remittances_effected=this.business.remittances_effected
      }
  },
  mounted () {
  },
  methods: {
      ...mapActions('business', [
      'addBusiness',
      'updateBusiness'
    ]),  
    async submitBusinessData(){
        this.$v.formData.$touch()
        if (this.$v.$invalid) {
            return true
        }
        let  response;
        if (this.business) { response = await this.updateBusiness(this.formData) } 
        else { response = await this.addBusiness(this.formData)  } 
        if (response.data) { 
            this.isLoading = false
            window.toastr['success'](this.$tc('profile.financial_institutions.saved_message'))
            return true
        }
    }
  }
}
</script>
